// extracted by mini-css-extract-plugin
module.exports = {"container":"TimeEntryHeader-module--container--16Vuj","date":"TimeEntryHeader-module--date--1eV9y"};